import { Flex, Skeleton, SkeletonCircle, VStack } from '@chakra-ui/react';

export const ChatLoader = () => {
  return (
    <VStack spacing={0} flex={1} justifyContent="flex-end">
      <Flex pt={4} alignItems="flex-end">
        <SkeletonCircle />
        <Flex pl={4}>
          <Skeleton width="200px" height="70px" />
        </Flex>
      </Flex>
      <Flex pt={4} alignItems="flex-end">
        <SkeletonCircle />
        <Flex pl={4}>
          <Skeleton width="200px" height="230px" />
        </Flex>
      </Flex>
    </VStack>
  );
};
